import FieldModel from './field.model'

let storeContent = utils.generateStore({
   FieldModel,
   fields: [],
   table: '',
   table_type: '',
   show_link_modal: false,
   has_add: false,
   show_remove_links: false,
   selected_fields: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addField(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               await api.fetchEndpoint({
                  resource: 'event',
                  action: 'add:event_field',
                  data: {
                     event_code: ctx.getters.table,
                     name: data.name,
                     alias: data.alias,
                     type: data.type.selected_option,
                     date: {
                        format: data.type.form_data.format,
                        time: data.type.form_data.time,
                        time_format: data.type.form_data.time_format,
                     },
                     nullable: data.nullable,
                     description: data.description,
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "dashboard",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchField',{table: ctx.getters.table})
               ctx.commit('show_create_modal', false)
               $notify('success', 'Field Created', `Field ${data.alias || data.name} successfully created.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async addFieldFaker(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let faker =  data.faker
               if(!faker.includes('{{')){
                  faker = `{{${data.faker}}}`
               }
               
               await api.fetchEndpoint({
                  resource: 'playground',
                  action: 'add:table_field',
                  data: {
                     table_code: ctx.getters.table,
                     name: data.name,
                     alias: data.alias,
                     faker,
                     type: data.type.selected_option,
                     date: {
                        format: data.type.form_data.format,
                        time: data.type.form_data.time,
                        time_format: data.type.form_data.time_format,
                     },
                     nullable: data.nullable,
                     description: data.description,
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "dashboard",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchField',{table: ctx.getters.table})
               ctx.commit('show_create_modal', false)
               $notify('success', 'Field Created', `Field ${data.alias || data.name} successfully created.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async linkFieldToTable(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'field',
                  action: 'link:table',
                  data: {
                     field_id: ctx.getters.selected_fields[0]._id,
                     table: data.table,
                     foreign_field: data.foreign_field,
                  },
                  meta_data: {}
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchField',{table: ctx.getters.table})
               ctx.commit('show_link_modal', false)
               $notify('success', 'Field Linked', `Field ${res.result.field.name} successfully linked.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async unlinkFieldToTable(ctx) {
         try {
            ctx.commit('loading', true)

            for (const field of ctx.getters.selected_fields) {
               let res = await api.fetchEndpoint({
                  resource: 'field',
                  action: 'remove:table_link',
                  data: {
                     field_id: field._id
                  },
                  meta_data: {}
               })
            }

            await ctx.dispatch('fetchField',{table: ctx.getters.table})
            ctx.commit('show_remove_links', false)
            $notify('success', 'Field Links Removed', `<b>${ctx.getters.selected_fields.length}</b> Field Links successfully removed.`, 5)
            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async updateField(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'update',
                  data: {
                     id: ctx.getters.selected_fields[0]._id,
                     record: {
                        is_accessible: data.is_accessible,
                        alias: data.alias,
                        description: data.description,
                        type: data.type.selected_option,
                        date: {
                           format: data.type.form_data.format,
                           time: data.type.form_data.time,
                           time_format: data.type.form_data.time_format,
                        },
                     }
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "field",
                  }
               })

               await payload.ref.resetForms()
               await ctx.dispatch('fetchField',{table: ctx.getters.table})
               ctx.commit('show_edit_modal', false)
               $notify('success', 'Field Updated', `Field ${data.name} successfully updated.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteField(ctx, payload) {
         try {
            ctx.commit('loading', true)

            for (const field of ctx.getters.selected_fields) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'delete',
                  data: {
                     id: field._id,
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "field",
                  }
               })
            }

            await ctx.dispatch('fetchField',{table: ctx.getters.table})
            ctx.commit('show_delete_modal', false)
            $notify('success', 'Field Deleted', `<b>${ctx.getters.selected_fields.length}</b> Field successfully deleted.`, 5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {
         if (payload.action === 'field:edit') {
            let FieldModel = ctx.getters.FieldModel
            FieldModel.forms.editField.data = payload.rows[0]

            ctx.commit('FieldModel', FieldModel)
            ctx.commit('show_edit_modal', true)
            ctx.commit('selected_fields', payload.rows)
         } else if (payload.action === 'field:delete') {
            ctx.commit('delete_message', `<b>${payload.rows.length}</b> Field`)
            ctx.commit('show_delete_modal', true)
            ctx.commit('selected_fields', payload.rows)
         } else if (payload.action === 'field:view') {
            // $session.set('selected_fields',payload.rows[0])
         } else if (payload.action === 'field:link_table') {
            if(payload.rows[0].link && payload.rows[0].link.table){
               $notify('error', 'Field Already Linked', `Field already has a link to a table`, 5)
               return null;
            }
            
            ctx.commit('selected_fields', payload.rows)
            ctx.commit('show_link_modal',true)
         } else if (payload.action === 'field:unlink_table') {
            for (let i = 0; i < payload.rows.length; i++) {
               const row = payload.rows[i];
               
               if(!row?.link?.table){
                  $notify('error', 'Table Link Missing', `The field ${row.alias || row.name} has no table link`, 5)
                  return true
               }
            }
            ctx.commit('delete_message', `<b>${payload.rows.length}</b> Field Links`)
            ctx.commit('show_remove_links', true)
            ctx.commit('selected_fields', payload.rows)
         }
      },
      async fetchField(ctx,{table, is_link_field}) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        table_code: table || ctx.getters.table
                     }
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "field",
               }
            })

            if(!is_link_field){
               ctx.commit('fields', res.result.records);
            }else{
               let Model = utils.appendSelectData({
                  Model: ctx.getters.FieldModel,
                  forms: ['link_table'],
                  model: 'foreign_field',
                  label: 'name',
                  dataField: 'code',
                  data: res.result.records
               })
               ctx.commit('FieldModel', Model)
            }

         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            let Model = utils.appendSelectData({
               Model: ctx.getters.FieldModel,
               forms: ['select_date'],
               model: 'time',
               label: 'name',
               dataField: 'code',
               data: ctx.getters.fields
            })

            // Fetch Accessible Tables
            let res = await api.fetchEndpointSecure({
               resource: 'commons',action: 'list',
               data: {
                  rules: {
                     match: {
                        is_accessible: true,
                     }
                  }
               },
               meta_data: {service: "analytics",collection: "table"}
            })

            Model = utils.appendSelectData({
               Model: ctx.getters.FieldModel,
               forms: ['link_table'],
               model: 'table',
               label: 'name',
               dataField: 'code',
               data: res.result.records
            })
            ctx.commit('FieldModel', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx,table) {
         try {
            // set has add to display add field button
            let table_type = table.split('_')[0]
            if(['events','playgrounds'].includes(table_type)){
               ctx.commit('table_type',table_type)
               ctx.commit('has_add',true)
            }else{
               ctx.commit('table_type','')
               ctx.commit('has_add',false)
            }


            ctx.commit('table',table)
            await ctx.dispatch('fetchField',{table})
            await ctx.dispatch('fetchFormData')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
      async selectFieldChanged(ctx,payload){
         try {
            if(payload.form.model === 'table' && payload.data && payload.data.length > 3){
               ctx.commit('loading',true)
               await ctx.dispatch('fetchField',{table: payload.data, is_link_field: true})
               ctx.commit('loading',false)
            }
         } catch (err) {
            throw err
         }
      }
   }
};